import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

async function getCampaignsCount(workspaceId: string): Promise<number> {
  return (await get(`workspaces/${workspaceId}/campaigns-count`)).count;
}

export default function useCampaignsCount(workspaceId: string) {
  const { campaignsKeys } = getQueryKeys(workspaceId);

  const { data: campaignsCount, isLoading: isLoadingCampaignsCount } = useQuery(
    {
      queryKey: campaignsKeys.count(),
      queryFn: () => getCampaignsCount(workspaceId),
    },
  );

  return {
    campaignsCount,
    isLoadingCampaignsCount,
  };
}
